import angular from 'angular';
import NetSalesWidgetComponent from './net-sales-widget-component';
import NetSalesRoutingModule from './net-sales-widget-routing-module';
import NetSalesHistoryPageModule from './components/net-sales-history-page/net-sales-history-page-module';
import NetSalesGameListModule from './components/net-sales-game-list/net-sales-game-list-module';

export default angular
  .module('net-sales-widget', [NetSalesHistoryPageModule.name, NetSalesRoutingModule.name, NetSalesGameListModule.name])
  .component('netSalesWidget', new NetSalesWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/net-sales/net-sales-widget-module.js